export default {
  data: () => ({
    CASH: {
      key: 'Cash',
      value: 'gotówka/płatność przy odbiorze'
    },
    ONE_DAY: {
      key: '1Day',
      value: '1 dzień'
    },
    SEVEN_DAYS: {
      key: '7Days',
      value: '7 dni'
    },
    FOURTEEN_DAYS: {
      key: '14Days',
      value: '14 dni'
    },
    THIRTY_DAYS: {
      key: '30Days',
      value: '30 dni'
    },
    UNDEFINED: {
      key: 'undefined',
      value: 'Do negocjacji'
    },
    OTHERS: {
      key: 'others',
      value: 'Inne (patrz uwagi)'
    }
  }),
  methods: {
    getPaymentConditions() {
      return [
        this.CASH,
        this.ONE_DAY,
        this.SEVEN_DAYS,
        this.FOURTEEN_DAYS,
        this.THIRTY_DAYS,
        this.UNDEFINED,
        this.OTHERS
      ]
    },
    getPaymentConditionLabel(value) {
      const result = this.getPaymentConditions().find((tc) => tc.key === value)

      return result ? result.value : ''
    }
  }
}
